const SAFE_EXTERNAL_LINK_PROTOCOLS = new Set([
  "http:",
  "https:",
  "mailto:",
  "tel:",
]);

/** A link a frame reported, if the app may open it outside the frame. */
export function safeExternalHref(href: string): string | null {
  try {
    const url = new URL(href);
    return SAFE_EXTERNAL_LINK_PROTOCOLS.has(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}

/** Maps a viewport point to CSS pixels inside a (possibly zoomed) iframe. */
export function framePointFromClient(
  iframe: HTMLIFrameElement,
  point: { x: number; y: number },
): { x: number; y: number } {
  const rect = iframe.getBoundingClientRect();
  const scaleX =
    rect.width > 0 && iframe.clientWidth > 0
      ? iframe.clientWidth / rect.width
      : 1;
  const scaleY =
    rect.height > 0 && iframe.clientHeight > 0
      ? iframe.clientHeight / rect.height
      : 1;
  return {
    x: (point.x - rect.left) * scaleX,
    y: (point.y - rect.top) * scaleY,
  };
}
